import UploadContin from './UploadContin';

export default UploadContin;
